import React from 'react'

const Filter = ({ color = 'black', fontSize = 24 }: { color?: string, fontSize?: number }) => {
  return (
    <svg
      width={fontSize}
      height={fontSize}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M22 6.5H16'
        stroke={color}
        strokeWidth='2.3'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M6 6.5H2'
        stroke={color}
        strokeWidth='2.3'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M10 10C8.067 10 6.5 8.433 6.5 6.5C6.5 4.567 8.067 3 10 3C11.933 3 13.5 4.567 13.5 6.5C13.5 8.433 11.933 10 10 10Z'
        stroke={color}
        strokeWidth='2.3'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M22 17.5H18'
        stroke={color}
        strokeWidth='2.3'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M8 17.5H2'
        stroke={color}
        strokeWidth='2.3'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M14 21C12.067 21 10.5 19.433 10.5 17.5C10.5 15.567 12.067 14 14 14C15.933 14 17.5 15.567 17.5 17.5C17.5 19.433 15.933 21 14 21Z'
        stroke={color}
        strokeWidth='2.3'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}

export default Filter
